var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-timeline",
    [
      _vm._l(_vm.binnacles, function(binnacleItem) {
        return _c(
          "app-timeline-item",
          {
            key: binnacleItem.bitacoraId,
            attrs: {
              icon: "InfoIcon",
              variant: _vm.getSeverity(binnacleItem.severidad)
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
              },
              [
                _c("h6", [_vm._v(_vm._s(binnacleItem.usuarioNombre))]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("dateCompleteFormat")(binnacleItem.fecha)) +
                      " "
                  )
                ])
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
              },
              [
                _c("p", [_vm._v(_vm._s(binnacleItem.mensaje))]),
                _c("div", { staticClass: "mb-1 mb-sm-0" }, [
                  _c(
                    "div",
                    [
                      binnacleItem.tipoVista == -1 ||
                      binnacleItem.tipoVista == 0
                        ? _c("b-avatar", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "mr-50",
                            attrs: {
                              title: "Registro Visible solo para Admin",
                              text: "O",
                              size: "24",
                              icon: "eye-slash-fill",
                              variant: "secondary"
                            }
                          })
                        : _vm._e(),
                      _c("b-avatar", {
                        directives: [
                          {
                            name: "has-permission",
                            rawName: "v-has-permission",
                            value: "FEB99",
                            expression: "'FEB99'"
                          },
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "mr-50 add-code",
                        attrs: {
                          title: "Copiar Seguimiento",
                          text: "S",
                          size: "24",
                          icon: "bug",
                          variant: "success"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.copyToClipboard(
                              binnacleItem.seguimientoId
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        )
      }),
      _vm.isLoading
        ? _c("app-timeline-item", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-content-center align-items-center"
              },
              [
                _c("b-spinner", {
                  staticClass: "mr-2",
                  attrs: { variant: "primary" }
                }),
                _c("small", [_vm._v("Cargando...")])
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.isLoading && _vm.actualPage < _vm.totalPages
        ? _c(
            "app-timeline-item",
            {
              on: {
                "~click": function($event) {
                  return _vm.loadMorePages($event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-content-center align-items-center"
                },
                [_c("small", [_vm._v("Cargar mas registros")])]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }